import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { InactivityService } from './services/inactivity.service';
import { Error500Service } from './services/error-500.service';
import { Error500ModalComponent } from './helpers/Error500.component';
import { GlobalLoaderComponent } from './helpers/global-loader.component';
import { GoogleAnalyticsService } from '../app/services/google-analytics/google-analytics.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    Error500ModalComponent,
    CommonModule,
    GlobalLoaderComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'Intermediarios';
  showError500Modal$;

  constructor(
    private inactivityService: InactivityService,
    private error500Service: Error500Service,
    private gAnalytics: GoogleAnalyticsService,
    private router: Router
  ) {
    this.showError500Modal$ = this.error500Service.showModal$;
  }

  ngOnInit(): void {
    // Tracking de rutas con Google Analytics
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        const path = event.urlAfterRedirects
        this.gAnalytics.trackPageView(path);
      });
  }


  @HostListener('window:mousemove')
  @HostListener('window:keydown')
  @HostListener('window:click')
  @HostListener('window:scroll')
  onUserActivity() {
    this.inactivityService.registerUserActivity();
  }
}
